import { ActionIcon, Box, Button, Flex, Image, Modal, ScrollArea, Stack, Text } from "@mantine/core";
import { IconMail, IconX } from "@tabler/icons-react";
import {
  ECOSYSTEM_CORRIDOR_HEAD_DETAIL_SECTIONS,
  ECOSYSTEM_CORRIDOR_HEAD_MAILTO,
} from "@/pages/ecosystem-heads/components/ecosystemCorridorPromo.util";

const MODAL_NAVY = "#04305c";
const PROMO_LOGO_HEIGHT = 44;
const CONTENT_MAX_HEIGHT = 400;

type EcosystemCorridorHeadDetailsModalProps = {
  opened: boolean;
  onClose: () => void;
};

export default function EcosystemCorridorHeadDetailsModal({
  opened,
  onClose,
}: EcosystemCorridorHeadDetailsModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size={860}
      padding={0}
      radius="lg"
      withCloseButton={false}
      title=""
      overlayProps={{ backgroundOpacity: 0.55, blur: 2 }}
      styles={{
        body: { padding: 0 },
        content: { overflow: "hidden" },
      }}
    >
      <Box
        p={{ base: 12, sm: 16 }}
        style={{
          backgroundColor: MODAL_NAVY,
        }}
      >
        <Flex
          direction={{ base: "column", sm: "row" }}
          gap={{ base: 12, sm: 16 }}
          align="stretch"
          mih={{ base: 380, sm: 440 }}
        >
          <Stack
            w={{ base: "100%", sm: 160 }}
            miw={{ sm: 160 }}
            justify="space-between"
            gap="md"
            py={{ base: 2, sm: 4 }}
            px={{ base: 2, sm: 0 }}
            align="stretch"
            style={{ flexShrink: 0 }}
          >
            <Box
              px={12}
              py={10}
              style={{
                borderRadius: 12,
                backgroundColor: "#FFFFFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                lineHeight: 0,
              }}
            >
              <Image src="/gtLogo.svg" alt="GTsetu" h={PROMO_LOGO_HEIGHT} w="auto" />
            </Box>

            <Button
              component="a"
              href={ECOSYSTEM_CORRIDOR_HEAD_MAILTO}
              size="sm"
              radius="md"
              fullWidth
              styles={{
                root: {
                  fontWeight: 600,
                  backgroundColor: "#FFFFFF",
                  color: MODAL_NAVY,
                  "&:hover": { backgroundColor: "#EFF6FF" },
                },
              }}
            >
              Contact Us
            </Button>
          </Stack>

          <Box
            style={{
              position: "relative",
              flex: 1,
              minWidth: 0,
              borderRadius: 14,
              backgroundColor: "#FFFFFF",
              overflow: "hidden",
            }}
          >
            <ActionIcon
              onClick={onClose}
              variant="subtle"
              aria-label="Close"
              size="md"
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 2,
                color: MODAL_NAVY,
              }}
              styles={{
                root: {
                  "&:hover": { backgroundColor: "#EFF6FF" },
                },
              }}
            >
              <IconX size={18} stroke={2.25} />
            </ActionIcon>

            <ScrollArea.Autosize mah={CONTENT_MAX_HEIGHT} type="auto" offsetScrollbars>
              <Stack gap={24} p={{ base: "md", sm: "lg" }} pr={{ base: "md", sm: 36 }}>
                {ECOSYSTEM_CORRIDOR_HEAD_DETAIL_SECTIONS.map((section) => (
                  <Stack key={section.title} gap={8}>
                    <Text fw={700} size="sm" tt="uppercase" c="#0F172A" lh={1.3}>
                      {section.title}
                    </Text>
                    <Text size="sm" c="#334155" lh={1.55}>
                      {section.body}
                    </Text>
                  </Stack>
                ))}

                <Flex align="center" gap={4}>
                  <IconMail size={18} />
                  <Text size="sm" c="#334155" lh={1.55}>  
                    Contact us : team@gtsetu.com
                  </Text>
                </Flex>
              </Stack>
            </ScrollArea.Autosize>
          </Box>
        </Flex>
      </Box>
    </Modal>
  );
}
